export const DarkTheme: Theme = {
    accentColor: "#1b8fff",
    accentColors: [
        "#1B8FFF",
        "#0DDEAD",
        "#66CC01",
        "#E9A80F",
        "#E95E10",
        "#EC0E0E",
        "#EB4DF8",
        "#8524FF",
        "#838383",
    ],
    headerColor: "#292b2e",
    secondaryHeaderColor: "#1b1c1e",
    leftSidebarColor: "#0f1011",
    mainContentColor: "#171719",
    closeBTN: "#923131",
    fontColor: {
        0: "#ffffff",
        50: "#cdcdd1",
        100: "#8f9194",
        200: "#6a6b6d",
        300: "#56575a",
    },
};

// export const DarkTheme: Theme = {
//     accentColor: "#1b8fff",
//     headerColor: "#222225",
//     secondaryHeaderColor: "#0f1011",
//     leftSidebarColor: "#080808",
//     mainContentColor: "#2d2d30",
//     fontColor: {
//         0: "#ffffff",
//         50: "#cdcdd1",
//         100: "#7f8082",
//         200: "#5e5f61",
//     },
// };
